import React from 'react';
import { Layout } from '../components/Layout';
import { MailIcon, YoutubeIcon, LinkedinIcon, FacebookIcon } from 'lucide-react';
export function About() {
  return <Layout data-id="element-88">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-89">
        {/* Hero Section */}
        <div className="text-center mb-16" data-id="element-90">
          <h1 className="text-5xl font-bold text-black mb-4" data-id="element-91">
            About the Founder
          </h1>
          <p className="text-xl text-gray-700" data-id="element-92">Meet Victoria Ndu</p>
        </div>
        {/* Founder Profile */}
        <div className="max-w-5xl mx-auto" data-id="element-93">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-94">
            <div data-id="element-95">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGcafTVhrzcsDLw46KBtYJ/IMG_8666.jpg" alt="Victoria Ndu" className="w-full rounded-2xl shadow-2xl" data-id="element-96" />
            </div>
            <div data-id="element-97">
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-98">
                Victoria Ndu
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-99">
                <p data-id="element-100">
                  Victoria Ndu is a CSR and sustainability leader, productivity
                  and peak performance coach, bestselling author, and tech
                  community builder. She manages large-scale social impact
                  programs at a multinational, where she designs and executes
                  initiatives across education, financial inclusion,
                  environment, and digital inclusion, touching thousands of
                  lives across Nigeria.
                </p>
                <p data-id="element-101">
                  With over ten years of global experience in community and
                  programs management, Victoria is passionate about creating
                  pathways for learning, growth, and impact. She is currently
                  the Head of CSR, Airtel Nigeria, served as the Akwa Ibom state
                  lead/CM for the Three Million Tech Talent (3MTT) an initiative
                  of the Federal Government, championing tech inclusion and
                  empowerment in Nigeria.
                </p>
                <p data-id="element-102">
                  Her dynamic coaching framework, The DOER System, helps
                  individuals overcome stagnation, boost productivity, and
                  achieve audacious goals by combining clarity, focus, and
                  execution. Through her platform, Voices with Victoria, she
                  amplifies untold stories of African excellence, inspiring
                  others to rise above limitations and lead lives of purpose.
                </p>
                <p data-id="element-103">
                  Victoria's work has earned her prestigious accolades,
                  including recognition as one of Nigeria's Top 10 Young Persons
                  by JCI. She is a member of ChangemakersXchange and a Bosch
                  Alumni Fellow. A sought-after speaker and trainer, she
                  delivers high-energy, transformative talks that challenge
                  audiences to rethink their potential and embrace growth. She's
                  married to a senior tech professional and they have a
                  beautiful baby girl.
                </p>
              </div>
            </div>
          </div>
          {/* Contact Section */}
          <div className="bg-gradient-to-br from-voices-cream to-white rounded-2xl p-8 md:p-12 border-l-8 border-voices-red" data-id="element-104">
            <h3 className="text-3xl font-bold text-black mb-6 text-center" data-id="element-105">
              Connect with Victoria
            </h3>
            <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-106">
              <a href="mailto:victorianwanna1@gmail.com" className="flex items-center gap-3 p-4 bg-white rounded-lg hover:shadow-lg transition-shadow" data-id="element-107">
                <MailIcon size={24} className="text-voices-red" data-id="element-108" />
                <div data-id="element-109">
                  <div className="font-semibold text-black" data-id="element-110">Email</div>
                  <div className="text-sm text-gray-600" data-id="element-111">
                    victorianwanna1@gmail.com
                  </div>
                </div>
              </a>
              <a href="https://youtube.com/@victoriandu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 bg-white rounded-lg hover:shadow-lg transition-shadow" data-id="element-112">
                <YoutubeIcon size={24} className="text-voices-red" data-id="element-113" />
                <div data-id="element-114">
                  <div className="font-semibold text-black" data-id="element-115">YouTube</div>
                  <div className="text-sm text-gray-600" data-id="element-116">
                    Voices with Victoria
                  </div>
                </div>
              </a>
              <a href="https://www.linkedin.com/in/victorianwanna/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 bg-white rounded-lg hover:shadow-lg transition-shadow" data-id="element-117">
                <LinkedinIcon size={24} className="text-voices-red" data-id="element-118" />
                <div data-id="element-119">
                  <div className="font-semibold text-black" data-id="element-120">LinkedIn</div>
                  <div className="text-sm text-gray-600" data-id="element-121">Victoria Ndu</div>
                </div>
              </a>
              <a href="https://web.facebook.com/victoria.nwanna.5" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 bg-white rounded-lg hover:shadow-lg transition-shadow" data-id="element-122">
                <FacebookIcon size={24} className="text-voices-red" data-id="element-123" />
                <div data-id="element-124">
                  <div className="font-semibold text-black" data-id="element-125">Facebook</div>
                  <div className="text-sm text-gray-600" data-id="element-126">Victoria Ndu</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}